import React from "react";
import InlineEditInputText from "../../common/widgets/InlineEditInputText.js";
import CandidateProfileInlineEditInput from "./CandidateProfileInlineEditInput.js";

/**
 * Generic component for all report editable text fields
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export default function CandidateProfileInlineEditInputText(props) {
  return (
    <CandidateProfileInlineEditInput
      InlineEditInputComponent={InlineEditInputText}
      {...props}
    />
  );
}
